import axios from 'axios';

export const getConvrrtCookieConfig = async function () {
    try {
        const response = await axios.post('/app/convrrtLandingPageFunnel/generateToken');

        return response.data;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);

        return '';
    }
};

export const getConvrrtLandingSites = async function() {
    try {
        const response = await axios.get('/app/convrrtLandingPageFunnel/sites');

        const landingPagesSites = response.data.sites;

        return Object.keys(landingPagesSites).map((key) => {
            return { label: landingPagesSites[key].name, value: landingPagesSites[key].id };
        });
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);

        return [];
    }
};


export const getConvrrtLandingPages = async function(pageId) {
    try {
        const response = await axios.get(`/app/convrrtLandingPageFunnel/sites/${pageId}/pages`);

        const landingPages = response.data.pages;

        return Object.keys(landingPages).map((key) => {
            const formId = landingPages[key].forms[0]?.id ?? landingPages[key].id;

            return { label: landingPages[key].name, value: formId };
        });
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);

        return [];
    }
};

export const getLeadBucketIdsByPageIds = async function(pageIds) {
    try {
        return await axios.post('/app/convrrtLandingPageFunnel/getLeadBucketFunnelMapByLeadBucketId', pageIds)
            .then((res) => {
                return res.data;
            });
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);

        return [];
    }
};

export const deleteLeadBucketIdsByIds = async function(funnelBucketIds) {
    try {
        await axios.post('/app/convrrtLandingPageFunnel/deleteLeadBucketFunnelMapById', funnelBucketIds);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
    }
};

export const deleteLeadFunnelBucketMaps = async function(funnelBucketIds) {
    try {
        await axios.post('/app/convrrtLandingPageFunnel/deleteLeadBucketFunnelMapById', funnelBucketIds);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
    }
};

export const saveNewLeadbucketFunnelMapping = async function(data) {
    const response = await axios.post('/app/convrrtLandingPageFunnel', data);

    return response;
};

export const addOrUpdateConvrrtParams = function (convrrtLandingPageId, cellId, funnelId) {
    let searchString = `&funnelId=${funnelId}&nodeId=${cellId}`;

    if (convrrtLandingPageId) {
        const siteId = `&siteId=${encodeURIComponent(convrrtLandingPageId)}`;

        searchString += siteId;
    }

    return searchString;
};

export const getConvrrtUrl = function (convrrtLandingPageId, cellId, funnelId) {
    const { location: { host } } = window;

    const pathname = '/app/funnel/convrrtRedirect';

    const url = encodeURIComponent(`https://${host}${pathname}`);

    const value = `?redirectUrl=${url}`;

    const searchString = `${value}${addOrUpdateConvrrtParams(convrrtLandingPageId, cellId, funnelId)}`;

    const baseUrl = window.location.hostname.includes('infusiontest')
        ? 'https://pages.infusiontest.com/campaign-redirect' : 'https://landingpages.infusionsoft.com/campaign-redirect';

    return `${baseUrl}${searchString}`;
};
